import { useId } from "react";

const DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

// A number whose digits roll like reels (iOS widgets). Cells are keyed by place from the right,
// so 99 -> 100 keeps the reels in place. Screen readers get the plain number.
export function RollingNumber({ value, format, className = "" }) {
  const text = format ? format(value) : new Intl.NumberFormat().format(value);
  const chars = [...text];
  let place = 0;
  const cells = chars.map((ch, i) => {
    if (!/\d/.test(ch)) return <span key={`s${chars.length - i}`}>{ch}</span>;
    const p = place++;
    return (
      <span key={`d${chars.slice(i).filter((c) => /\d/.test(c)).length}`} className="ios-roll-cell">
        <span className="ios-roll-reel" style={{ "--d": ch, "--p": p }}>
          {DIGITS.map((d) => <span key={d}>{d}</span>)}
        </span>
      </span>
    );
  });
  return (
    <span className={`ios-roll ${className}`}>
      <span className="ios-sr">{text}</span>
      <span aria-hidden="true" style={{ display: "inline-flex" }}>{cells}</span>
    </span>
  );
}

// A small trend line with a soft fill; values oldest first.
export function Sparkline({ values, label }) {
  const id = `spark${useId().replace(/[^a-z0-9]/gi, "")}`;
  if (!Array.isArray(values) || values.length < 2) return null;
  const W = 120, H = 34, top = 3, bottom = H - 3;
  const max = Math.max(...values), min = Math.min(...values), span = max - min || 1;
  const pts = values.map((v, i) => [(i / (values.length - 1)) * W, bottom - ((v - min) / span) * (bottom - top)]);
  const line = pts.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)} ${y.toFixed(1)}`).join(" ");
  return (
    <svg className="ios-spark" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" role="img" aria-label={label}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="currentColor" stopOpacity="0.22" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${line} L${W} ${H} L0 ${H} Z`} fill={`url(#${id})`} />
      <path className="ios-spark-line" d={line} />
    </svg>
  );
}
